import React from 'react';
import Comment from '@atlaskit/icon/core/comment';
import PersonNewIcon from '@atlaskit/icon/core/person';
import Approval from '@atlaskit/icon/core/person-added';
import AppAccessIcon from '@atlaskit/icon/glyph/app-access';
import BaseCommentIcon from '@atlaskit/icon/glyph/comment';
import PersonIcon from '@atlaskit/icon/glyph/person';
import { token } from '@atlaskit/tokens';

export const CommentsIcon = () => (
	<Comment
		LEGACY_fallbackIcon={BaseCommentIcon}
		LEGACY_primaryColor="color.icon.subtle"
		label="Comment"
		spacing="none"
		LEGACY_size="small"
		color={token('color.icon')}
	/>
);

export const ApprovalsIcon = () => (
	<Approval
		LEGACY_fallbackIcon={AppAccessIcon}
		LEGACY_primaryColor="color.icon.subtle"
		label="Approvals"
		spacing="none"
		LEGACY_size="small"
		color={token('color.icon')}
	/>
);

export const ReviewerIcon = () => (
	<PersonNewIcon
		LEGACY_fallbackIcon={PersonIcon}
		LEGACY_primaryColor="color.icon.subtle"
		label="Reviewer"
		spacing="none"
		LEGACY_size="small"
		color={token('color.icon')}
	/>
);
